import { render, staticRenderFns } from "./TermsForFixedPriceModelModal.vue?vue&type=template&id=47bb854d&scoped=true&"
import script from "./TermsForFixedPriceModelModal.vue?vue&type=script&lang=ts&"
export * from "./TermsForFixedPriceModelModal.vue?vue&type=script&lang=ts&"
import style0 from "./TermsForFixedPriceModelModal.vue?vue&type=style&index=0&id=47bb854d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb854d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSpacer})
